import { request } from './request.js'

export const getWebSystems = (config = {}) => request.get('web_systems', config)
